module.exports = __webpack_public_path__ + "img/logo-sms.e693fac2.webp";